export const optionsIn: KeyframeEffectOptions = {easing: 'ease', duration: 200, fill: 'forwards'};
export const optionsOut: KeyframeEffectOptions = {...optionsIn, direction: 'reverse'};

export const slideFrames = [
    {transform: 'translateY(25%)', opacity: 0},
    {transform: 'translateY(0)', opacity: 1},
];

export const fadeFrames = [{opacity: 0}, {opacity: 1}];
